<template>
  <section class="edit-container sme-container__info ">
    <div class="flex">
      <div class="flex-1">
        <div class="flex-sb-center">
          <h2>Edit Claims Status</h2>
          <span>
            <v-button
              gray
              @click="handleCancel">Cancel</v-button>
            <v-button
              green
              @click="handlerSave">Save</v-button>
          </span>
        </div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules"
        >
          <div class="form-container">
            <div class="form-item">
              <span>Status</span>
              <el-form-item
                ref="status"
                prop="status"
              >
                <v-radio-group
                  v-model="formData.status"
                  border
                  is-slot
                  :list="claimsList">
                  <template
                    slot-scope="{item}"
                  >
                    <span class="box">
                      <span
                        class="span-status"
                        :class="{
                          'blue': [1].includes(item.id),
                          'purple': [2].includes(item.id),
                          'green': [3].includes(item.id),
                          'red': [4].includes(item.id),}">
                        {{ item.name }}
                      </span>
                    </span>
                  </template>
                </v-radio-group>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Remark</span>
              <el-form-item
                ref="remark"
                prop="remark"
              >
                <v-input
                  v-model="formData.remark"
                  type="textarea"
                  :rows="4" />
              </el-form-item>
            </div>
            <h3>Upload Support Document</h3>
            <table class="table table_no_title">
              <tr
                v-for="(item,index) in formData.files"
                :key="index"
                class="tr">
                <td>
                  <p>{{item.name}}</p>
                  <p class="color-gray60 fs-12 fw-400">{{item.upload_date}}</p>
                </td>
                <td
                  align="right"
                  class="blue pointer"
                >
                  <span
                    class="blue pointer"
                    @click="openFile(item.url)">{{item.client_name}}</span>
                </td>
                <td align="right">
                  <span>
                    <font-awesome-icon
                      icon="trash-alt"
                      class="red pointer mg-r-15"
                      @click="handleDel(index)"></font-awesome-icon>
                    <font-awesome-icon
                      icon="edit"
                      class="blue pointer"
                      @click="handleEdit(index)"></font-awesome-icon>
                  </span>
                </td>
              </tr>
            </table>
            <v-button
              green
              @click="handlerUpload" >Upload File</v-button>
          </div>
        </el-form>
      </div>
      <ticket-remark
        class="mg-l-20"
        :ticket-id="ticketId"
      ></ticket-remark>
    </div>
    <send-email-sms
      ref="send-email-sms"
      :is-edit="true"
      updateContent
      :form="detailData"
      :initContent="initContent"
      :init-refer-content="initContent"
      :emailListTitle="emailListTitle"
      :is-fina="isFina"
      :is-only-referrer="isFina&&[3,4].includes(formData.status)"
      :emailTitle="emailTitle"
      @skip="handlerSkip"
      @send="handlerSend" />
    <upload-claim-doc
      v-model="showDialog"
      :form="fileData"
      @upload="handleUploadSuccess"></upload-claim-doc>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import FileContainer from '@/views/components/file-container'
import {editTicketClaim, getClaimForm} from '@/api/ticket'
import MixinRules from '@/mixins/rules'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import {setClaimStatus} from '@api/claim'
import uploadClaimDoc from './claim/upload-claim-doc'
import TicketRemark from '@/views/tickets/components/ticket-remark'
export default {
  name: 'EditClaimStatus',
  components: {
    SendEmailSms,
    uploadClaimDoc,
    TicketRemark
  },
  mixins: [MixinOptions,MixinRules],
  props: {
    claimId: [String, Number],
    claimStatus: {
      type: Number,
      default: 0
    },
    renewOrderSn:{
      type: String,
      default: ''
    },
    detailData:{
      type: Object,
      default: () => {}
    },
    relation:{
      type: Object,
      default: () => {}
    },
    form:{
      type: Object,
      default: () => {}
    },
    customers:{
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      formData: {
        status: 0, // 0:received,1:processing,2:setted
        remark: '',
        files:[]
      },
      is_send: 0,
      content: '',
      showDialog:false,
      fileData:{},
      isEdit:false,
      index:-1
    }
  },
  computed:{
    ticketId(){
      let {ticket_id} = this.$route.query
      return ticket_id
    },
    claimsList(){
      let {ticket_claim_status} = this.globalOptions

      return ticket_claim_status.filter((item)=>{return item.id!=0}) || []
    },
    productId(){
      let {product_id} = this.detailData||{}
      return Number(product_id)
    },
    isMotor(){
      return this.productId == 11
    },
    isTravelOrPA(){
      let {type_of_insured} = this.detailData||{}
      return type_of_insured==2&&this.productId==18||[14].includes(this.productId)
    },
    isFina(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform == 2
    },
    initContent(){
      let content = ''
      let {status} = this.formData||{}
      let {claim_processing_url_data,claim_no_cheque_url_data,claim_success_url_data,claim_reject_url_data} = this.relation||{}
      if(status == 1){
        content = claim_processing_url_data
      }else if(status == 2){
        content =claim_no_cheque_url_data
      }else if(status == 3){
        content = claim_success_url_data
      }
      else if(status == 4){
        content = claim_reject_url_data
      }
      return content
    },
    emailTitle(){
      let title = ''
      let {status} = this.formData||{}
      let {claim_processing_title,claim_no_cheque_title,claim_success_title,claim_reject_title} = this.relation||{}
      if(status == 1){
        title = claim_processing_title
      }else if(status == 2){
        title =claim_no_cheque_title
      }else if(status == 3){
        title =claim_success_title
      }
      else if(status == 4){
        title = claim_reject_title
      }
      return title
    },
    emailListTitle(){
      let {status} = this.formData||{}
      let {claim_list_title,claim_reject_list_title} = this.relation||{}
      return status==4?claim_reject_list_title:claim_list_title
    },
    customerData(){
      return this.customers
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        let {status_files,status_remark,status} = val||{}
        this.formData.files = status_files||[]
        this.formData.status = status
        this.formData.remark = status_remark
      }
    }
  },
  methods: {
    handleCancel(){
      this.$emit('cancel')
      this.$emit('refresh')
    },
    handleDel(index){
      this.formData.files.splice(index, 1)
    },
    handleEdit(index){
      this.fileData = this.formData.files[index]
      this.isEdit=true
      this.index = index
      this.showDialog = true
      // this.formData.files.splice(index, 1)
    },
    handlerUpload(){
      this.isEdit=false
      this.index = -1
      this.fileData = {}
      this.showDialog = true
    },
    handleUploadSuccess(data){
      if(this.isEdit){
        this.formData.files[this.index] = JSON.parse(JSON.stringify(data))
      }else
        this.formData.files.push(JSON.parse(JSON.stringify(data)))
      this.isEdit = false
    },
    handlerSave() {
      this.$refs.form.validate((valid, rules) => {
        if (valid) {
          if(this.renewOrderSn){
            this.$emit('nextStep', 5)
          }else{
            if(this.isFina&&![3,4].includes(this.formData.status))
              this.network().setClaimStatus()
            else
              this.$refs['send-email-sms'].changeDialog()
          }
        }
      })
    },

    handlerSkip(){
      this.is_send = 0
      this.network().setClaimStatus()
    },
    handlerSend(content,type,data){
      let {referrer_content} = data
      this.is_send = 1
      this.content = this.isFina?referrer_content:content
      this.network().setClaimStatus()
    },
    deleteOtherFile({ index }) {
      this.formData.other_file.splice(index, 1)
    },
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    network() {
      return {
        setClaimStatus: async () => {
          const { data } = await setClaimStatus({
            claim_id: this.claimId,
            ...this.formData,
            is_send: this.is_send,
            content: this.content,
          })
          this.$message({
            type: 'success',
            message: data.message_language
          })
          // this.$refs['send-email-sms'].changeDialog()
          this.dialog = false
          this.$emit('success', this.formData.status)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../quoting/sme/info";
.edit-container {
  position: relative;
  padding: 15px;
  flex: 1;
  .abs-top-right {
    top: 20px;
    right: 15px;
  }
  .form-container {
    //width: 80%;
  }
  .box{
    //padding: 20px;
  }
  .span-status {
    margin-right: 5px;
    padding: 2px 8px;
    border-radius: 25px;
    white-space: nowrap;
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    &.blue {
      border: 1px solid #0366D6;
      color: #fff;
      background: #0366D6;
    }
    &.green {
      border: 1px solid #28A745;
      color: #fff;
      background: #28A745;
    }
    &.red{
      border: 1px solid #D73A49;
      color: #fff;
      background: #D73A49;
    }
  }
  /deep/.el-radio-group{
    width: 100%;
    .el-radio{
      width: calc(33.3% - 20px);
      &.is-bordered{
        padding: 20px;
        height: auto;

      }
    }
  }


}
</style>
